import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DocTurnStatus {
    plus_service_turn: string | null;
    plus_id: number | null;
}

export const initialState: DocTurnStatus = {
    plus_service_turn: null,
    plus_id: null,
};

export const DocTurnStatus = createSlice({
    name: "docturnstatus",
    initialState,
    reducers: {
        setDocTurnStatus: (state, action: PayloadAction<string>) => {
            state.plus_service_turn = action.payload;
        },
        setPlus_id: (state, action: PayloadAction<number>) => {
            state.plus_id = action.payload;
        },
    },
});

export const { setDocTurnStatus, setPlus_id } = DocTurnStatus.actions;
export default DocTurnStatus.reducer;
